angular.module('eCareVault.common.directives').directive('popover', ['$compile', '$timeout', '$templateCache', '$rootScope', 'BroadcastService', function ($compile, $timeout, $templateCache, $rootScope, BroadcastService) {
    return {
        replace: true,
        scope: true,
        link: function (scope, element, attrs) {

            $timeout(function () {
                // grab template
                const tpl = angular.element($templateCache.get(attrs.ecvPopoverTemplateId));
                //grab popover parts of template
                const template = {
                    title: tpl.find('.template-title').contents(),
                    content: tpl.find('.template-content').contents()
                };

                //render template with angular
                const content = $compile(template.content)(scope);
                const title = $compile(template.title)(scope);
                const posFunc = function (context, source) {
                    const position = $(source).offset();
                    const docScroll = $(document).scrollTop();
                    if ((position.top - docScroll) <= 300){
                        return "bottom";
                    }
                    return "top";
                };

                $(element).popover({
                    html: true,
                    trigger: attrs.ecvPopoverTrigger,
                    placement: attrs.ecvPopoverPlacement || posFunc,
                    content: content,
                    title: title,
                    sanitize:false,
                    viewport: { selector: attrs.ecvPopoverSelector || '.cmenu-vwport', padding: 5 },
                    container: attrs.ecvPopoverContainer
                });
                $(element).on('hide.bs.popover', function ($event) {
                   if($event.currentTarget.id == 'sub-options-popover'){
                       BroadcastService.broadcast('sub-options-popover-hide', [attrs.ecvPopoverContainer]);
                   }
                });
                $(element).on('show.bs.popover', function ($event) {
                  BroadcastService.broadcast('other-popovers-hide', [attrs.ecvPopoverContainer]);
                    if($event.currentTarget.id == 'sub-options-popover'){
                        BroadcastService.broadcast('sub-options-popover-open', [attrs.ecvPopoverContainer]);
                    }
                    if($event.currentTarget.id == 'folder-options-popover') {
                        BroadcastService.broadcast('filter-popover-hide');
                    }
                    //hide filter popover on global dashboard page.
                    if ($event.currentTarget.id == 'filter-popover-icon') {
                        BroadcastService.broadcast('folder-options-popover-hide');
                    }

                });
                scope.$digest()
            });

        }

    };
}]);
